import React, {useState , useRef} from 'react';
import Multiselect from 'multiselect-react-dropdown';
import 'react-toastify/dist/ReactToastify.css';
import {trans} from "../../utils";
import $ from "jquery";
import ReactToPrint, { PrintContextConsumer } from "react-to-print";

const Assignee = ({data,sendRequest,data2,data5}) => {
    const [assign, setAssign] = useState({
        staff_id: '-1',
        notes_to_assignee: '',
        action_option:'',
        _method : 'put',
        isLoading: false,
        custom_function : true
    });
    const handleNotesChange = event => {
        setAssign({...assign,notes_to_assignee: event.target.value} );
    };

    const handleAssigneeChange = event => {
        setAssign({...assign,staff_id: event.target.value} );
    };
    const handleAssignForm = event =>
    {
        event.preventDefault();
        sendRequest(assign)
    }
    const handleProgress = () =>
    {
        const data =  {
            _method : 'put',
            custom_function : true
        }
        sendRequest(data)
    }

    const [finish, setFinish] = useState({
        failure_type_id: [],
        delivered_to: '',
        _method : 'put',
        isLoading: false,
        custom_function : true,
        req_type:'finish'
    });

    const handleFinishChange = event =>
    {
        event.preventDefault();
        sendRequest(finish)
    }

    const handleDeliveredToChange = event => {
        setFinish({...finish,delivered_to: event.target.value} );
    };
    const handleClose = () =>
    {
        const data =  {
            _method : 'put',
            custom_function : true,
            req_type:'close'
        }
        sendRequest(data)
    }
    const handleApprove = () =>
    {
        const data =  {
            _method : 'put',
            custom_function : true,
            req_type:'approve'
        }
        sendRequest(data)
    }
    const [reopen, setReopen] = useState({
        comment:'',
        _method : 'put',
        custom_function : true,
        req_type:'reopen'
    });
    const handleReopenChange = event => {
        setReopen({...reopen,comment: event.target.value} );
    };
    const handleReOpenForm = event =>
    {
        event.preventDefault();
        sendRequest(reopen)
    }
    window.$('[data-toggle="tooltip"]').tooltip();

    const options = data5;
    const [selectedValues,setSelectedValues] = useState([]);
    const onSelect = (selectedList, selectedItem) => {
        setSelectedValues(selectedList)
        var failure_ids = selectedList.map(el=>el.id);
        setFinish({...finish,failure_type_id: failure_ids} );
    }
    const onRemove = (selectedList, selectedItem) => {
        setSelectedValues(selectedList)
        var failure_ids = selectedList.map(el=>el.id);
        setFinish({...finish,failure_type_id: failure_ids} );
    }

    const componentRef = useRef();

    return(
        <>
            <div className="card-header">
                <div className="card-title m-0">
                    <h3 className="fw-bolder m-0">{trans('WO Information')}</h3>
                    { data.priority &&
                    <span className="badge badge-success me-auto ml-2"
                          data-container="body" data-toggle="tooltip" data-placement="top" title={trans('Priority')}>{trans(data.priority.title)}</span>
                    }
                </div>
                <div className="d-flex my-4">
                    { data.status_data  &&
                    data.status_data.title_en == "Created" && (data.is_wo_creator || data.is_admin) &&
                    <button type="button" className="btn btn-light-primary waves-effect waves-light" data-toggle="modal" data-target="#AssigneeModal">
                        <i className="bi bi-plus fs-3"></i> {trans('Assign')}</button>}
                    { data.status_data  &&
                    data.status_data.title_en == "Reopened" && (data.is_wo_creator || data.is_admin) &&
                    <button type="button" className="btn btn-light-primary waves-effect waves-light" data-toggle="modal" data-target="#AssigneeModal">
                        <i className="bi bi-plus fs-3"></i> {trans('Assign')}</button>}
                    { data.status_data  &&
                    data.status_data.title_en == "Assigned" && (data.is_assignee || data.is_admin) &&
                    <button type="button" className="btn btn-light-warning waves-effect waves-light" onClick={handleProgress}>
                        {trans('Start')}</button>
                    }
                    { data.status_data  &&
                    data.status_data.title_en == "Skipped" && (data.is_assignee || data.is_admin) &&
                    <button type="button" className="btn btn-light-warning waves-effect waves-light" onClick={handleProgress}>
                        {trans('Start')}</button>
                    }
                    { data.status_data  &&
                    data.status_data.title_en == "Pending" && (data.is_assignee || data.is_admin) &&
                    <button type="button" className="btn btn-light-warning waves-effect waves-light" onClick={handleProgress}>
                        {trans('Start')}</button>
                    }
                    { data.status_data  &&
                    data.status_data.title_en == "Active" && (data.is_assignee || data.is_admin) &&
                    <button type="button" className="btn btn-light-danger waves-effect waves-light" data-toggle="modal" data-target="#FinisheModal">
                        {trans('Finish')}</button>
                    }
                    { data.status_data  &&
                    data.status_data.title_en == "Signed Off" && (data.is_wo_creator || data.is_admin || data.is_ticket_creator) &&
                    <button type="button" className="btn btn-light-success waves-effect waves-light"  onClick={handleClose}>
                        {trans('Closed')}</button>
                    }
                    { data.status_data  &&
                    data.status_data.title_en == "Pending for Approval" &&  (data.is_wo_creator || data.is_admin) &&
                        <button type="button" className="btn btn-light-info waves-effect waves-light" data-toggle="modal" data-target="#ReopenModal" >
                            {trans('Re-open')}</button>
                    }
                    { data.status_data  &&
                    data.status_data.title_en == "Pending for Approval" && (data.is_wo_creator || data.is_admin || data.is_ticket_creator) &&
                        <button type="button" className="btn btn-light-success waves-effect waves-light" onClick={handleApprove}>
                            {trans('Approve')}</button>
                    }
                </div>

            </div>
            <div className="modal fade" id="AssigneeModal" tabIndex="-1" role="dialog" aria-labelledby="AssigneeModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">{trans('Assign')}</h5>
                            <button type="button" className="close" data-dismiss="modal"
                                    aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <form onSubmit={handleAssignForm}>

                            <div className="modal-body">

                                <div className="form-group">
                                    <label htmlFor="recipient-name"
                                           className="col-form-label">{trans('Assign to')} * :</label>
                                    <select className="form-select form-select-sm"
                                            aria-label=".form-select-sm example"
                                            id="inputAssign" type="text" name="assign"
                                            onChange={handleAssigneeChange}
                                            value={assign.staff_id}
                                    >
                                        <option value="-1"  disabled>{trans('Select an option')}</option>
                                        {data2.map(name => (
                                            <option key={name.id} value={name.id} >{trans(name.name)}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="message-text"
                                           className="col-form-label">{trans('Notes To Assignee')}:</label>
                                    <input
                                        className="form-control"
                                        type="text" name="notes"
                                        value={assign.notes_to_assignee}
                                        onChange={handleNotesChange}
                                    />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary"
                                        data-dismiss="modal">{trans('Close')}
                                </button>
                                <button className="btn btn-primary"  type="submit">{trans('Submit')}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="ReopenModal" tabIndex="-1" role="dialog" aria-labelledby="ReopenModallabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">{trans('Assign')}</h5>
                            <button type="button" className="close" data-dismiss="modal"
                                    aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <form onSubmit={handleReOpenForm}>
                            <div className="modal-body">
                                <div className="form-group">
                                    <label htmlFor="message-text"
                                           className="col-form-label">{trans('Re-opening comments')} *:</label>
                                    <input
                                        className="form-control"
                                        type="text" name="notes"
                                        value={reopen.comment}
                                        onChange={handleReopenChange}
                                    />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary"
                                        data-dismiss="modal">{trans('Close')}
                                </button>
                                <button className="btn btn-primary"  type="submit">{trans('Submit')}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="FinisheModal" tabIndex="-1" role="dialog" aria-labelledby="FinishModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">{trans('Finish')}</h5>
                            <button type="button" className="close" data-dismiss="modal"
                                    aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <form onSubmit={handleFinishChange}>

                            <div className="modal-body">

                                <div className="form-group">
                                    <label htmlFor="recipient-name"
                                           className="col-form-label">{trans('Failure Type')} * :</label>
                                    <Multiselect
                                        options={options} // Options to display in the dropdown
                                        selectedValues={selectedValues} // Preselected value to persist in dropdown
                                        onSelect={onSelect} // Function will trigger on select event
                                        onRemove={onRemove} // Function will trigger on remove event
                                        displayValue="title" // Property name to display in the dropdown options
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="recipient-name"
                                           className="col-form-label">{trans('Delivered to')} :</label>
                                    <select className="form-select form-select-sm"
                                            aria-label=".form-select-sm example"
                                            id="inputAssign" type="text" name="assign"
                                            onChange={handleDeliveredToChange}
                                            value={finish.delivered_to}
                                    >
                                        <option value="" >{trans('Select an option')}</option>
                                        {data2.map(name => (
                                            <option key={name.id} value={name.id} >{trans(name.name)}</option>
                                        ))}
                                    </select>
                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary"
                                        data-dismiss="modal">{trans('Close')}
                                </button>
                                <button className="btn btn-primary"  type="submit">{trans('Submit')}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className="card-body p-4"  ref={componentRef}>
                <>
                    <div class="print-2 text-center">
                        { data.status_data &&
                        <h3 class="mb-3 text-center">{trans('WO')} #{data.id}</h3>
                    }
                    </div>
                </>
                <>
                    <div class="print-2 text-center">
                        {data.ticket &&
                        <h3 class="text-center">{trans('Ticket')} #{data.ticket.id} </h3>}
                    </div>
                </>
                { data.room_space_item &&
                <>
                    <div className="fw-bolder mt-3">{trans('Common Name')} :</div>
                    <div className="text-gray-600">
                        {trans(data.room_space_item.assign_asset_item.asset_item.common_name)}
                    </div>
                </>
                }

                { data.room_space_item &&
                <>
                    <div className="separator mb-2 mt-2"></div>
                    <div className="fw-bolder mt-3">{trans('Allocate Asset/ Item Ref.')}  :</div>

                    <div className="text-gray-600">
                        <a href={'/RoomSpaceItem/View/'+data.room_space_item.id} target="_blank">
                            {trans(data.room_space_item.assign_asset_item.reference)}
                        </a></div>
                </>
                }
                { data.ticket && data.ticket.requested_by_user &&
                <>
                    <div className="separator mb-2 mt-2"></div>
                    <div className="fw-bolder mt-3">{trans('Requested by')}  :</div>
                    <div className="text-gray-600">
                        {trans(data.ticket.requested_by_user.name)}
                    </div>
                </>
                }
                { data.room_space_item && data.room_space_item.facility.customer &&
                <>
                    <div className="separator mb-2 mt-2"></div>
                    <div className="fw-bolder mt-3">{trans('Customer')}  :</div>
                    <div className="text-gray-600">
                        {trans(data.room_space_item.facility.customer.name)}
                    </div>
                </>
                }
                { data.room_space_item && data.room_space_item.facility.sub_customer &&
                <>
                    <div className="separator mb-2 mt-2"></div>
                    <div className="fw-bolder mt-3">{trans('Sub Customer')}  :</div>
                    <div className="text-gray-600">
                        {trans(data.room_space_item.facility.sub_customer.name)}
                    </div>
                </>
                }
                { data.room_space_item && data.room_space_item.facility &&
                <>
                    <div className="separator mb-2 mt-2"></div>
                    <div className="fw-bolder mt-3">{trans('Facility')}  :</div>
                    <div className="text-gray-600">
                        {trans(data.room_space_item.facility.name)}
                    </div>
                </>
                }

                { data.room_space_item && data.room_space_item.building &&
                <>
                    <div className="separator mb-2 mt-2"></div>
                    <div className="fw-bolder mt-3">{trans('Building')}  :</div>
                    <div className="text-gray-600">
                        {trans(data.room_space_item.building.title)}
                    </div>
                </>
                }
                { data.room_space_item && data.room_space_item.floor.hasOwnProperty("name") &&
                <>
                    <div className="separator mb-2 mt-2"></div>
                    <div className="fw-bolder mt-3">{trans('Floor')}  :</div>
                    <div className="text-gray-600">
                        {trans(data.room_space_item.floor.name)}
                    </div>
                </>
                }
                { data.room_space_item && data.room_space_item.room &&
                <>
                    <div className="separator mb-2 mt-2"></div>
                    <div className="fw-bolder mt-3">{trans('Room')}  :</div>
                    <div className="text-gray-600">
                        {trans(data.room_space_item.room.room_space_name)}
                    </div>
                </>
                }
                { data.room_space_item && data.room_space_item.room.department &&
                <>
                    <div className="separator mb-2 mt-2"></div>
                    <div className="fw-bolder mt-3">{trans('Department')}  :</div>
                    <div className="text-gray-600">
                        {trans(data.room_space_item.room.department.title)}
                    </div>
                </>
                }

                {data.room_space_item && data.room_space_item.assign_asset_item.asset_item.ecri > 0 ?
                    <>
                        <div className="separator mb-2 mt-2"></div>
                        <div className="fw-bolder mt-3">{trans('ECRI Name')} :</div>
                        <div className="text-gray-600">{trans(data.room_space_item.assign_asset_item.asset_item.ecri.ecri_name)}</div>
                    </>
                    : ''
                }

                {data.ticket && data.ticket.description &&
                <>
                    <div className="separator mb-2 mt-2"></div>
                    <div className="fw-bolder mt-3">{trans('Description')} :</div>
                    <div className="text-gray-600">{trans(data.ticket.description)}</div>
                </>
                }

                {data.room_space_item && data.room_space_item.assign_asset_item.asset_item.ecri > 0 ?
                    <>
                        <div className="separator mb-2 mt-2"></div>
                        <div className="fw-bolder mt-3">{trans('ECRI Code')} :</div>
                        <div className="text-gray-600">{trans(data.room_space_item.assign_asset_item.asset_item.ecri.ecri_code)}</div>
                    </>
                    : ''
                }

                <div className="separator mb-2 mt-2"></div>
                <div className="row mt-5">
                    <div className="col-md-6 text-center">
                        <div className="align-items-center mb-10">
                            <div className="d-flex flex-column">
                                <h5 className="text-gray-800 fw-bolder">{trans('Total Actual Cost')}</h5>
                                <div className="fw-bold">
                                    <span className="fs-3x fw-bolder text-primary ">{trans(data.total_actual_cost)}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 text-center">
                        <div className="align-items-center mb-10">
                            <div className="d-flex flex-column">
                                <h5 className="text-gray-800 fw-bolder">{trans('Total EST Cost')}</h5>
                                <div className="fw-bold">
                                    <span className="fs-3x fw-bolder text-primary">{trans(data.total_est_cost)}</span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="text-center">
                    <ReactToPrint
                        trigger={() => <button className="btn btn-success print-btn"> Print WO </button>}
                        content={() => componentRef.current}
                    />
                </div>
            </div>
        </>
    )

}
export default Assignee;
